const IMAGE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".gif",
  ".avif",
  ".tif",
  ".tiff",
];

function isImageAsset(path) {
  const cleanPath = path.split("?")[0].toLowerCase();
  return IMAGE_EXTENSIONS.some((ext) => cleanPath.endsWith(ext));
}

export default function cloudfrontLoader({ src, width, quality }) {
  const ditCdn = process.env.NEXT_PUBLIC_DIT_CDN || "";
  const assetsCdn = process.env.NEXT_PUBLIC_ASSETS_URL || "";
  const q = quality || 75;

  // public folder images
  if (src.startsWith("/")) {
    return src;
  }

  if (src.startsWith("http")) {
    if (
      ditCdn &&
      assetsCdn &&
      src.startsWith(assetsCdn) &&
      isImageAsset(src)
    ) {
      const path = src.replace(assetsCdn, "").replace(/^\/+/, "");

      return `${ditCdn}/${path}?resize.width=${width}&resize.fit=cover&quality=${q}`;
    }

    return src;
  }

  const cleanSrc = src.replace(/^\/+/, "");

  if (ditCdn && isImageAsset(cleanSrc)) {
    return `${ditCdn}/${cleanSrc}?resize.width=${width}&resize.fit=cover&quality=${q}`;
  }

  if (assetsCdn) {
    return `${assetsCdn}/${cleanSrc}`;
  }

  return `/${cleanSrc}`;
}